"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
/**
* @export
* @enum {string}
*/
var TableauNlpSemanticmodelDetailedLensErrorCodeEnum;
(function (TableauNlpSemanticmodelDetailedLensErrorCodeEnum) {
    TableauNlpSemanticmodelDetailedLensErrorCodeEnum["UnspecifiedError"] = "UNSPECIFIED_ERROR";
    TableauNlpSemanticmodelDetailedLensErrorCodeEnum["Ok"] = "OK";
    TableauNlpSemanticmodelDetailedLensErrorCodeEnum["DatasourceConnectionError"] = "DATASOURCE_CONNECTION_ERROR";
    TableauNlpSemanticmodelDetailedLensErrorCodeEnum["InternalError"] = "INTERNAL_ERROR";
    TableauNlpSemanticmodelDetailedLensErrorCodeEnum["DatasourceNotFound"] = "DATASOURCE_NOT_FOUND";
    TableauNlpSemanticmodelDetailedLensErrorCodeEnum["AuthenticationFailed"] = "AUTHENTICATION_FAILED";
    TableauNlpSemanticmodelDetailedLensErrorCodeEnum["UnauthorizedAccess"] = "UNAUTHORIZED_ACCESS";
    TableauNlpSemanticmodelDetailedLensErrorCodeEnum["NoCredentialsGiven"] = "NO_CREDENTIALS_GIVEN";
    TableauNlpSemanticmodelDetailedLensErrorCodeEnum["LensIndexingFailed"] = "LENS_INDEXING_FAILED";
})(TableauNlpSemanticmodelDetailedLensErrorCodeEnum = exports.TableauNlpSemanticmodelDetailedLensErrorCodeEnum || (exports.TableauNlpSemanticmodelDetailedLensErrorCodeEnum = {})); /**
* @export
* @enum {string}
*/
var TableauNlpSemanticmodelDetailedLensUnsupportedCodeEnum;
(function (TableauNlpSemanticmodelDetailedLensUnsupportedCodeEnum) {
    TableauNlpSemanticmodelDetailedLensUnsupportedCodeEnum["IsSupported"] = "ANALYSIS_IS_SUPPORTED";
    TableauNlpSemanticmodelDetailedLensUnsupportedCodeEnum["TooManyFields"] = "ANALYSIS_TOO_MANY_FIELDS";
    TableauNlpSemanticmodelDetailedLensUnsupportedCodeEnum["CredentialsMissing"] = "ANALYSIS_CREDENTIALS_MISSING";
    TableauNlpSemanticmodelDetailedLensUnsupportedCodeEnum["SlowPerformance"] = "ANALYSIS_SLOW_PERFORMANCE";
    TableauNlpSemanticmodelDetailedLensUnsupportedCodeEnum["HasUserReference"] = "ANALYSIS_HAS_USER_REFERENCE";
    TableauNlpSemanticmodelDetailedLensUnsupportedCodeEnum["DisabledByOwner"] = "ANALYSIS_DISABLED_BY_OWNER";
    TableauNlpSemanticmodelDetailedLensUnsupportedCodeEnum["DuplicateFieldLabels"] = "ANALYSIS_DUPLICATE_FIELD_LABELS";
})(TableauNlpSemanticmodelDetailedLensUnsupportedCodeEnum = exports.TableauNlpSemanticmodelDetailedLensUnsupportedCodeEnum || (exports.TableauNlpSemanticmodelDetailedLensUnsupportedCodeEnum = {})); /**
* @export
* @enum {string}
*/
var TableauNlpSemanticmodelDetailedLensAnalysisStatusEnum;
(function (TableauNlpSemanticmodelDetailedLensAnalysisStatusEnum) {
    TableauNlpSemanticmodelDetailedLensAnalysisStatusEnum["AnalysisStatusUnknown"] = "ANALYSIS_STATUS_UNKNOWN";
    TableauNlpSemanticmodelDetailedLensAnalysisStatusEnum["AnalysisPending"] = "ANALYSIS_PENDING";
    TableauNlpSemanticmodelDetailedLensAnalysisStatusEnum["Analyzing"] = "ANALYZING";
    TableauNlpSemanticmodelDetailedLensAnalysisStatusEnum["AnalysisDone"] = "ANALYSIS_DONE";
})(TableauNlpSemanticmodelDetailedLensAnalysisStatusEnum = exports.TableauNlpSemanticmodelDetailedLensAnalysisStatusEnum || (exports.TableauNlpSemanticmodelDetailedLensAnalysisStatusEnum = {}));
function TableauNlpSemanticmodelDetailedLensFromJSON(json) {
    return TableauNlpSemanticmodelDetailedLensFromJSONTyped(json, false);
}
exports.TableauNlpSemanticmodelDetailedLensFromJSON = TableauNlpSemanticmodelDetailedLensFromJSON;
function TableauNlpSemanticmodelDetailedLensFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'luid': !runtime_1.exists(json, 'luid') ? undefined : json['luid'],
        'name': !runtime_1.exists(json, 'name') ? undefined : json['name'],
        'indexedVersion': !runtime_1.exists(json, 'indexed_version') ? undefined : json['indexed_version'],
        'fields': !runtime_1.exists(json, 'fields') ? undefined : (json['fields'].map(_1.TableauNlpSemanticmodelLensFieldFromJSON)),
        'errorCode': !runtime_1.exists(json, 'error_code') ? undefined : json['error_code'],
        'unsupportedCode': !runtime_1.exists(json, 'unsupported_code') ? undefined : json['unsupported_code'],
        'analysisStatus': !runtime_1.exists(json, 'analysis_status') ? undefined : json['analysis_status'],
        'indexesLastUpdatedAt': !runtime_1.exists(json, 'indexes_last_updated_at') ? undefined : json['indexes_last_updated_at'],
        'nextRetryTime': !runtime_1.exists(json, 'next_retry_time') ? undefined : json['next_retry_time'],
        'indexValuesDisabled': !runtime_1.exists(json, 'index_values_disabled') ? undefined : json['index_values_disabled'],
        'maxNumberOfValuesIndexed': !runtime_1.exists(json, 'max_number_of_values_indexed') ? undefined : json['max_number_of_values_indexed'],
    };
}
exports.TableauNlpSemanticmodelDetailedLensFromJSONTyped = TableauNlpSemanticmodelDetailedLensFromJSONTyped;
function TableauNlpSemanticmodelDetailedLensToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'luid': value.luid,
        'name': value.name,
        'indexed_version': value.indexedVersion,
        'fields': value.fields === undefined ? undefined : (value.fields.map(_1.TableauNlpSemanticmodelLensFieldToJSON)),
        'error_code': value.errorCode,
        'unsupported_code': value.unsupportedCode,
        'analysis_status': value.analysisStatus,
        'indexes_last_updated_at': value.indexesLastUpdatedAt,
        'next_retry_time': value.nextRetryTime,
        'index_values_disabled': value.indexValuesDisabled,
        'max_number_of_values_indexed': value.maxNumberOfValuesIndexed,
    };
}
exports.TableauNlpSemanticmodelDetailedLensToJSON = TableauNlpSemanticmodelDetailedLensToJSON;
